import { loadStripe, Stripe } from '@stripe/stripe-js';

// Stripe publishable key - safe to expose on frontend
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise && stripePublishableKey) {
    stripePromise = loadStripe(stripePublishableKey);
  }
  return stripePromise || Promise.resolve(null);
}

// Stripe Price IDs - these need to be created in Stripe Dashboard
// Sophie will need to create these products/prices and add the IDs here
export const STRIPE_PRICES = {
  starter: {
    monthly: import.meta.env.VITE_STRIPE_PRICE_STARTER_MONTHLY || 'price_starter_monthly',
    yearly: import.meta.env.VITE_STRIPE_PRICE_STARTER_YEARLY || 'price_starter_yearly',
  },
  growth: {
    monthly: import.meta.env.VITE_STRIPE_PRICE_GROWTH_MONTHLY || 'price_growth_monthly',
    yearly: import.meta.env.VITE_STRIPE_PRICE_GROWTH_YEARLY || 'price_growth_yearly',
  },
  scale: {
    monthly: import.meta.env.VITE_STRIPE_PRICE_SCALE_MONTHLY || 'price_scale_monthly',
    yearly: import.meta.env.VITE_STRIPE_PRICE_SCALE_YEARLY || 'price_scale_yearly',
  },
} as const;

export type PriceTier = keyof typeof STRIPE_PRICES;
export type BillingInterval = 'monthly' | 'yearly';

export function getPriceId(tier: PriceTier, interval: BillingInterval): string {
  return STRIPE_PRICES[tier][interval];
}

// Check if Stripe is configured
export function isStripeConfigured(): boolean {
  return Boolean(stripePublishableKey);
}
